module.exports = __webpack_public_path__ + "static/media/multiple-choice-columns-cloud-1.32a76fe6.svg";